import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '../UI/Button';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Switch from '../UI/Switch';
import { FormControlLabel } from '@mui/material';
import { dateTimeFormat } from '../../util/DateUtil';

const useStyles = makeStyles(theme => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
    },
    submit: {
        // margin: theme.spacing(3, 0, 3),
        textTransform: 'none',
    },
    buscarBtn: {
        // margin: theme.spacing(3, 3, 3),
        textTransform: 'none',
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    menuIcon: {
        marginTop: '15px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    divAlunoFoto: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    gridAbaMenu: {
        display: 'flex',
        justifyContent: 'space-around'
    }
}));

const InstituicaoForm = ({
    instituicao,
    setInstituicao,
    clickSubmit
}) => {
    const classes = useStyles();


    const handleChange = (event) => {
        setInstituicao({
            ...instituicao,
            [event.target.name]: event.target.value
        })
    }


    const handleSwitch = (name, value) => {
        setInstituicao({
            ...instituicao,
            [name]: value,
        });
    };

    return (
        <>
            <Container className={classes.paper} component={Paper} >
                <Grid container justifyContent="space-between">
                    <Grid size={3}>
                        <CloseIcon
                            onClick={() => setInstituicao(null)}
                            className={classes.closeIcon}
                            fontSize='small'
                        />
                    </Grid>


                </Grid>

                <Typography variant="h6">
                    Cadastro Instituição
                </Typography>
                <Grid>
                    <form onSubmit={clickSubmit}>
                        <TextField
                            variant="outlined"
                            size="small"
                            margin="normal"
                            label="Descrição"
                            name="descricao"
                            autoFocus
                            onChange={handleChange}
                            value={instituicao && instituicao.descricao ? instituicao.descricao : ''}
                            fullWidth
                            slotProps={{
                                htmlInput: { maxLength: 80 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="CPF/CNPJ"
                            name="cpfCnpj"
                            onChange={handleChange}
                            value={instituicao && instituicao.cpfCnpj ? instituicao.cpfCnpj : ''}
                            slotProps={{
                                htmlInput: { maxLength: 20 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Endereço"
                            name="endereco"
                            onChange={handleChange}
                            value={instituicao && instituicao.endereco ? instituicao.endereco : ''}
                            slotProps={{
                                htmlInput: { maxLength: 200 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="CEP"
                            name="cep"
                            onChange={handleChange}
                            value={instituicao && instituicao.cep ? instituicao.cep : ''}
                            slotProps={{
                                htmlInput: { maxLength: 10 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Bairro"
                            name="bairro"
                            onChange={handleChange}
                            value={instituicao && instituicao.bairro ? instituicao.bairro : ''}
                            slotProps={{
                                htmlInput: { maxLength: 100 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Cidade"
                            name="cidade"
                            onChange={handleChange}
                            value={instituicao && instituicao.cidade ? instituicao.cidade : ''}
                            slotProps={{
                                htmlInput: { maxLength: 100 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Estado"
                            name="estado"
                            onChange={handleChange}
                            value={instituicao && instituicao.estado ? instituicao.estado : ''}
                            slotProps={{
                                htmlInput: { maxLength: 5 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Telefone Contato"
                            name="telefoneContato"
                            onChange={handleChange}
                            value={instituicao && instituicao.telefoneContato ? instituicao.telefoneContato : ''}
                            slotProps={{
                                htmlInput: { maxLength: 15 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Telefone Contato 2"
                            name="telefoneContato2"
                            onChange={handleChange}
                            value={instituicao && instituicao.telefoneContato2 ? instituicao.telefoneContato2 : ''}
                            slotProps={{
                                htmlInput: { maxLength: 15 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Email"
                            name="email"
                            onChange={handleChange}
                            value={instituicao && instituicao.email ? instituicao.email : ''}
                            slotProps={{
                                htmlInput: { maxLength: 200 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Código Banco"
                            name="codigoBanco"
                            onChange={handleChange}
                            value={instituicao && instituicao.codigoBanco ? instituicao.codigoBanco : ''}
                            slotProps={{
                                htmlInput: { maxLength: 10 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Dígito Código Banco"
                            name="digitoCodigoBanco"
                            onChange={handleChange}
                            value={instituicao && instituicao.digitoCodigoBanco ? instituicao.digitoCodigoBanco : ''}
                            slotProps={{
                                htmlInput: { maxLength: 2 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Agência"
                            name="agencia"
                            onChange={handleChange}
                            value={instituicao && instituicao.agencia ? instituicao.agencia : ''}
                            slotProps={{
                                htmlInput: { maxLength: 10 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Código Cedente"
                            name="codigoCedente"
                            onChange={handleChange}
                            value={instituicao && instituicao.codigoCedente ? instituicao.codigoCedente : ''}
                            slotProps={{
                                htmlInput: { maxLength: 20 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Dígito Código Cedente"
                            name="digitoCodigoCedente"
                            onChange={handleChange}
                            value={instituicao && instituicao.digitoCodigoCedente ? instituicao.digitoCodigoCedente : ''}
                            slotProps={{
                                htmlInput: { maxLength: 2 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Hostname"
                            name="hostname"
                            onChange={handleChange}
                            value={instituicao && instituicao.hostname ? instituicao.hostname : ''}
                            slotProps={{
                                htmlInput: { maxLength: 100 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Url Logo"
                            name="urlLogo"
                            onChange={handleChange}
                            value={instituicao && instituicao.urlLogo ? instituicao.urlLogo : ''}
                            slotProps={{
                                htmlInput: { maxLength: 200 }
                            }}
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Url Logo App"
                            name="urlLogoApp"
                            onChange={handleChange}
                            value={instituicao && instituicao.urlLogoApp ? instituicao.urlLogoApp : ''}
                            slotProps={{
                                htmlInput: { maxLength: 200 }
                            }}
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.livroHabilitado ? instituicao.livroHabilitado : ''}
                                    name="livroHabilitado"
                                />
                            }
                            label="Livro Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.avaliacaoHabilitado ? instituicao.avaliacaoHabilitado : ''}
                                    name="avaliacaoHabilitado"
                                />
                            }
                            label="Avaliação Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.mensagemHabilitado ? instituicao.mensagemHabilitado : ''}
                                    name="mensagemHabilitado"
                                />
                            }
                            label="Mensagem Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.muralHabilitado ? instituicao.muralHabilitado : ''}
                                    name="muralHabilitado"
                                />
                            }
                            label="Mural Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.smsLembreteHabilitado ? instituicao.smsLembreteHabilitado : ''}
                                    name="smsLembreteHabilitado"
                                />
                            }
                            label="SMS Lembrete Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.smsPendenciaHabilitado ? instituicao.smsPendenciaHabilitado : ''}
                                    name="smsPendenciaHabilitado"
                                />
                            }
                            label="SMS Pendência Habilitado"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.ativo ? instituicao.ativo : ''}
                                    name="ativo"
                                />
                            }
                            label="Ativo"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.comunicadoAprovacao ? instituicao.comunicadoAprovacao : ''}
                                    name="comunicadoAprovacao"
                                />
                            }
                            label="Comunicado Aprovação"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.bloqueiaEntradaCatracaInadimplente ? instituicao.bloqueiaEntradaCatracaInadimplente : ''}
                                    name="bloqueiaEntradaCatracaInadimplente"
                                />
                            }
                            label="Bloqueio Entrada Catraca Inadimplente"
                        />
                        <TextField
                            size="small"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Quant. Dias Antes Hoje Busca Inadimplente"
                            name="quantDiasAntesHojeBuscaInadimplente"
                            onChange={handleChange}
                            value={instituicao && instituicao.quantDiasAntesHojeBuscaInadimplente ? instituicao.quantDiasAntesHojeBuscaInadimplente : ''}
                            slotProps={{
                                htmlInput: { maxLength: 3 }
                            }}
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.servicoPresenca ? instituicao.servicoPresenca : ''}
                                    name="servicoPresenca"
                                />
                            }
                            label="Serviço Presença"
                        />
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    handleSwitch={handleSwitch}
                                    value={instituicao && instituicao.servicoPresenteFalta ? instituicao.servicoPresenteFalta : ''}
                                    name="servicoPresenteFalta"
                                />
                            }
                            label="Serviço Presente Falta"
                        />

                        <p
                            style={{ display: 'flex' }}
                        >
                            {"Criado em: " + (instituicao.createdAt ? dateTimeFormat(instituicao.createdAt) : '')}
                        </p>
                        <p
                            style={{ display: 'flex' }}
                        >
                            {"Última Atualização: " + (instituicao.lastModified ? dateTimeFormat(instituicao.lastModified) : '')}
                        </p>




                        <Grid containe style={{ margin: '20px' }} direction='row' spacing={3}>
                            <Grid>
                                <Button
                                    type="submit"
                                >
                                    Salvar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>

                </Grid>
            </Container>
        </ >
    );
}

export default InstituicaoForm;